import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentDialogReplyAvatarsList from './VeltCommentDialogReplyAvatarsList/VeltCommentDialogReplyAvatarsList';
import VeltCommentDialogReplyAvatarsRemainingCount from './VeltCommentDialogReplyAvatarsRemainingCount/VeltCommentDialogReplyAvatarsRemainingCount';
var VeltCommentDialogReplyAvatars = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-reply-avatars-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogReplyAvatars.List = VeltCommentDialogReplyAvatarsList;
VeltCommentDialogReplyAvatars.RemainingCount = VeltCommentDialogReplyAvatarsRemainingCount;
export default VeltCommentDialogReplyAvatars;
